import { observer } from 'mobx-react';
import React from 'react';
import { FunctionComponent } from 'react';
import { TempDayAvailability, TempHourAvailability } from '../../types';
import AddIcon from '~/asset/calendar/hours/add.svg';
import { Label, Text } from '~/component/text';
import { FormControlLabel, Grid, IconButton } from '@mui/material';
import strings from '~/constants/strings';
import { checkForOverlapping } from '../helpers';
import { IOSSwitch } from '~/component/switch/IOSSwitch';
import { TimeSelectRow } from '../TimeSelectRow';

export const weekDayArray = [
  strings.general.date.day_of_week_1,
  strings.general.date.day_of_week_2,
  strings.general.date.day_of_week_3,
  strings.general.date.day_of_week_4,
  strings.general.date.day_of_week_5,
  strings.general.date.day_of_week_6,
  strings.general.date.day_of_week_0,
  '祝日',
];

const styles = {
  dayContainer: {
    minWidth: 490,
    marginBottom: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    padding: '8px 16px',
  },
  iconButton: {
    width: 32,
    height: 32,
    padding: 4,
  },
  icon: {
    fontSize: 20,
    width: 20,
    height: 20,
  },
};

export const DaySetting: FunctionComponent<{
  day: TempDayAvailability;
  dayIndex: number;
  updateDay: (dayIndex: number, data: Partial<TempDayAvailability>) => void;
}> = observer((props) => {
  const { day, dayIndex, updateDay } = props;

  const handleToggleDayOff = (newState: boolean) => {
    const reverted = !newState;
    if (reverted === false && day.hours.length === 0) {
      updateDay(dayIndex, {
        dayOff: reverted,
        hours: [
          {
            from: {
              hour: null,
              minute: null,
            },
            to: {
              hour: null,
              minute: null,
            },
          },
        ],
      });
    } else {
      updateDay(dayIndex, {
        dayOff: reverted,
      });
    }
  };
  const handleUpdateHour = (hourIndex: number, data: TempHourAvailability) => {
    const newHours = JSON.parse(JSON.stringify(day.hours));
    newHours[hourIndex] = data;
    const overlap = checkForOverlapping(newHours);
    for (let i = 0; i < newHours.length; i++) {
      newHours[i].hasError = false;
    }
    overlap.forEach((index) => {
      newHours[index].hasError = true;
    });
    updateDay(dayIndex, {
      hours: newHours,
    });
  };
  const handleDeleteHour = (hourIndex: number) => {
    const newHours = JSON.parse(JSON.stringify(day.hours));
    newHours.splice(hourIndex, 1);
    const overlap = checkForOverlapping(newHours);
    for (let i = 0; i < newHours.length; i++) {
      newHours[i].hasError = false;
    }
    overlap.forEach((index) => {
      newHours[index].hasError = true;
    });
    if (newHours.length === 0) {
      updateDay(dayIndex, {
        dayOff: true,
        hours: newHours,
      });
    } else {
      updateDay(dayIndex, {
        hours: newHours,
      });
    }
  };
  const handleAddHour = () => {
    const newHours = JSON.parse(JSON.stringify(day.hours));
    newHours.push({
      from: {
        hour: null,
        minute: null,
      },
      to: {
        hour: null,
        minute: null,
      },
    });
    updateDay(dayIndex, {
      hours: newHours,
      dayOff: false,
    });
  };
  return (
    <Grid
      item
      // xs={12}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'space-between'}
      className=""
      style={styles.dayContainer}
    >
      <Grid
        item
        xs={11}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'flex-start'}
        // justifyContent={'center'}
      >
        <Grid
          item
          xs={4}
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Label
            text={weekDayArray[dayIndex]}
            className="color--green font--22 fontWeight--bold"
            style={{ marginRight: 32 }}
          />
          <FormControlLabel
            control={
              <IOSSwitch
                sx={{ m: 1 }}
                checked={!day.dayOff}
                onChange={(event) => handleToggleDayOff(event.target.checked)}
              />
            }
            label={''}
          />
        </Grid>
        {day.dayOff && (
          <Grid
            item
            xs={8}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
            sx={{ height: 42 }}
          >
            <Text text={strings.hours.dayOff} className="fontWeight--400 ml8" />
          </Grid>
        )}
        {!day.dayOff && (
          <Grid
            item
            xs={8}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            {day.hours.map((hour, index) => (
              <TimeSelectRow
                index={index}
                from={hour.from}
                to={hour.to}
                key={index}
                handleUpdateHour={handleUpdateHour}
                onDelete={handleDeleteHour}
                hasError={hour.hasError}
              />
            ))}
          </Grid>
        )}
      </Grid>
      <Grid
        item
        xs={1}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ height: 42 }}
      >
        <IconButton
          style={styles.iconButton}
          className="color--green"
          onClick={handleAddHour}
        >
          <img style={styles.icon} src={AddIcon} />
        </IconButton>
      </Grid>
    </Grid>
  );
});
